import { createRouteBundle } from 'redux-bundler';
import Compliance from 'root/components/views/Compliance';
import Error from 'root/components/views/Error';
import General from 'root/components/views/General';
import Loading from 'root/components/views/Loading';
import NotFound from 'root/components/views/NotFound';
import Team from 'root/components/views/Team';
import Workspace from 'root/components/views/Workspace';
import createBundleGroup from 'utils/createBundleGroup';

import {
  BILLING,
  COMPLIANCE,
  COMPLIANCE_10LDC_FAKE_URL,
  DEV_ROOT,
  DEV_ROOT_EMPTY,
  ERROR,
  GENERAL,
  ROOT,
  TEAM,
  WORKSPACE,
} from './APP_URLS';

export default createRouteBundle({
  ...createBundleGroup(General, [GENERAL, ROOT, DEV_ROOT, DEV_ROOT_EMPTY]),
  [BILLING]: General,
  [TEAM]: Team,
  [WORKSPACE]: Workspace,
  [COMPLIANCE]: Compliance,
  [ERROR]: Error,
  [COMPLIANCE_10LDC_FAKE_URL]: Loading,
  '*': NotFound /* eslint-disable-line */, // has to come last
});
